import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import get from 'lodash/get';

import styles from './ErrorList.module.css';

const ErrorList = ({ errorsList, style }) => (
  <div className={styles.container} style={style}>
    <ul>
      {map(errorsList, (row, index) => (
        <li key={index}>{get(row, 'message') || row}</li>
      ))}
    </ul>
  </div>
);

ErrorList.propTypes = {
  errorsList: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(
      PropTypes.shape({
        message: PropTypes.string,
      })
    ),
  ]).isRequired,
  style: PropTypes.shape({}),
};

ErrorList.defaultProps = {
  style: null,
};

export default ErrorList;
